import React, { useEffect, useState } from 'react';
import { Collapse, Space, Descriptions, Skeleton, Typography, Col, Row, Card, Image } from 'antd';
import { CheckSquareOutlined, CloseSquareOutlined, LoadingOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import Amplify, { API, Auth } from 'aws-amplify';
import { useParams } from 'react-router-dom';
import NetTable from './NetTable';
import YieldTable from './YieldTable';

const { Panel } = Collapse;

export default function QCContent() {

    const Bucket = "https://d1e9ilirjteg2w.cloudfront.net/";

    let { id } = useParams();

    const [items, setItems] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [title, setTitle] = useState();

    useEffect(() => {
        if (id !== undefined) {
            let current = [];
            current.push(id);
            getItems(current);
        }
    }, [id])

    async function getItems(props) {
        // Amplify.Logger.LOG_LEVEL = "DEBUG";
        const session = await Auth.currentCredentials();
        // console.log(session)
        const apiRequest = {
            body: {
                "ids": props,

            },
            headers: {
                "Content-Type": "application/json",
            },
        };

        return await API
            .post("MQC", "/api/jobs", apiRequest)
            .then(
                (data) => {
                    // console.log(data);
                    if (data.statusCode === 200) {
                        if (data.data[0].result_check_json !== "") {
                            setTitle(processModelName(data.data[0].model));
                            processData(Bucket + data.data[0].result_check_json);
                        }
                    } else {
                        setIsLoaded(true);

                    }
                },
                (error) => {
                    console.log(error);
                }
            );
    };


    useEffect(() => {
        if (items !== undefined) {
            console.log(items)
            setIsLoaded(true);
        } else {
            setIsLoaded(false);
        }
    }, [items])

    function processData(props) {
        fetch(props)
            .then(res => res.json())
            .then(result => {
                console.log(result)
                setItems(result);
            })
    }

    function processModelName(props) {
        let currentArr = props.split("/");
        // console.log(currentArr);
        return currentArr[currentArr.length - 1];
    }
    function getHeaders(props) {
        let currentObj = props[0];
        let headers = [];
        for (const key in currentObj) {
            headers.push(key);
        }
        // console.log(currentObj, headers)
        return headers;
    }

    function titleCase(str) {
        let newStr = str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
        return newStr;
    }

    return (
        <Space direction="vertical" size={30} style={{ width: "100%" }}>
            <>
                <Typography.Title level={2} style={{ color: "#3B75AF", textAlign: "center" }} >{isLoaded ? title : <LoadingOutlined />}</Typography.Title>

                {/* <Card style={{ borderRadius: "0.375rem" }}> */}
                <Collapse
                    expandIconPosition="end"
                    defaultActiveKey="check_reducing_equivalents_production"
                    // expandIcon={(panelProps) => {
                    //     return panelProps.isActive ? <DownOutlined /> : <RightOutlined />
                    // }}
                    expandIcon={(panelProps) => {
                        if (!isLoaded) {
                            return panelProps.isActive ? <DownOutlined /> : <RightOutlined />
                        } else if (panelProps.panelKey === "check_reducing_equivalents_production" || panelProps.panelKey === "check_energy_production" || panelProps.panelKey === "check_metabolite_production" || panelProps.panelKey === "check_metabolite_yield" || panelProps.panelKey === "check_biomass_production") {
                            return panelProps.isActive ? <DownOutlined style={{ color: "white" }} /> : <RightOutlined style={{ color: "white" }} />
                        } else {
                            return panelProps.isActive ? <DownOutlined /> : <RightOutlined />
                        }
                    }}
                    style={{ borderRadius: "0.375rem" }}
                >
                    <Panel
                        header={<a style={{ color: isLoaded ? "white" : "black" }}>Check Reducing Equivalents Production</a>}
                        key="check_reducing_equivalents_production"
                        extra={isLoaded ? (items.check_reducing_equivalents_production.score !== 0 ? <CheckSquareOutlined style={{ color: "white", fontSize: "20px" }} /> : <CloseSquareOutlined style={{ color: "white", fontSize: "20px" }} />) : <LoadingOutlined />}
                        style={{ background: isLoaded ? (items.check_reducing_equivalents_production.score !== 0 ? "#97bf60" : "#dc6068") : undefined }}
                    >
                        <Space style={{ width: "100%" }} direction="vertical" >
                            {
                                isLoaded
                                    ?
                                    <Space style={{ width: "100%" }} direction="vertical">
                                        <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                            {
                                                items.check_reducing_equivalents_production.Details !== undefined && items.check_reducing_equivalents_production.Details !== ""
                                                    ?
                                                    <Descriptions.Item label={titleCase("Details")}>
                                                        {
                                                            items.check_reducing_equivalents_production.Details.split("\n").map(e => {
                                                                return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                            })
                                                        }
                                                    </Descriptions.Item>
                                                    :
                                                    null
                                            }

                                            {
                                                items.check_reducing_equivalents_production.Summary !== undefined && items.check_reducing_equivalents_production.Summary !== ""
                                                    ?
                                                    <Descriptions.Item label={titleCase("Summary")}>
                                                        {
                                                            items.check_reducing_equivalents_production.Summary.split("\n").map(e => {
                                                                return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                            })
                                                        }
                                                    </Descriptions.Item>
                                                    :
                                                    null
                                            }

                                        </Descriptions>
                                        {
                                            items.check_reducing_equivalents_production.png !== undefined && items.check_reducing_equivalents_production.png !== ""
                                                ?
                                                <div style={{ textAlign: "center", width: "100%" }}>
                                                    <Image src={items.check_reducing_equivalents_production.png} style={{ textAlign: "center", maxWidth: "500px" }} />
                                                </div>
                                                :
                                                null
                                        }
                                    </Space>
                                    :
                                    <Skeleton active loading />
                            }
                        </Space>
                    </Panel>

                    <Panel
                        header={<a style={{ color: isLoaded ? "white" : "black" }}>Check Energy Production</a>}
                        key="check_energy_production"
                        extra={isLoaded ? (items.check_energy_production.score !== 0 ? <CheckSquareOutlined style={{ color: "white", fontSize: "20px" }} /> : <CloseSquareOutlined style={{ color: "white", fontSize: "20px" }} />) : <LoadingOutlined />}
                        style={{ background: isLoaded ? (items.check_energy_production.score !== 0 ? "#97bf60" : "#dc6068") : undefined }}
                    >
                        <Space style={{ width: "100%" }} direction="vertical" >
                            {
                                isLoaded
                                    ?
                                    <Space style={{ width: "100%" }} direction="vertical">
                                        <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                            {
                                                items.check_energy_production.Summary !== undefined && items.check_energy_production.Summary !== ""
                                                    ?
                                                    <Descriptions.Item label={titleCase("Details")}>{
                                                        items.check_energy_production.Details.split("\n").map(e => {
                                                            return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                        })
                                                    }</Descriptions.Item>
                                                    :
                                                    null
                                            }

                                            {
                                                items.check_energy_production.Summary !== undefined && items.check_energy_production.Summary !== ""
                                                    ?
                                                    <Descriptions.Item label={titleCase("Summary")}>{
                                                        items.check_energy_production.Summary.split("\n").map(e => {
                                                            return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                        })
                                                    }</Descriptions.Item>
                                                    :
                                                    null
                                            }

                                        </Descriptions>
                                        <div style={{ textAlign: "center", width: "100%" }}>
                                            {
                                                items.check_energy_production.png !== undefined && items.check_energy_production.png !== ""
                                                    ?
                                                    <div style={{ textAlign: "center", width: "100%" }}>
                                                        <Image src={items.check_energy_production.png} style={{ textAlign: "center", maxWidth: "500px" }} />
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </Space>
                                    :
                                    <Skeleton active loading />
                            }
                        </Space>
                    </Panel>

                    <Panel
                        header={<a style={{ color: isLoaded ? "white" : "black" }}>Check Metabolite Production</a>}
                        key="check_metabolite_production"
                        extra={isLoaded ? (items.check_metabolite_production.score !== 0 ? <CheckSquareOutlined style={{ color: "white", fontSize: "20px" }} /> : <CloseSquareOutlined style={{ color: "white", fontSize: "20px" }} />) : <LoadingOutlined />}
                        style={{ background: isLoaded ? (items.check_metabolite_production.score !== 0 ? "#97bf60" : "#dc6068") : undefined }}
                    >
                        <Space style={{ width: "100%" }} direction="vertical" >
                            {
                                isLoaded
                                    ?
                                    <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                        {
                                            items.check_metabolite_production.Details !== undefined && items.check_metabolite_production.Details !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("Details")}>
                                                    {items.check_metabolite_production.Details}
                                                </Descriptions.Item>
                                                :
                                                null
                                        }

                                        {
                                            items.check_metabolite_production.Summary !== undefined && items.check_metabolite_production.Summary !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("Summary")}>{
                                                    items.check_metabolite_production.Summary.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }


                                    </Descriptions>
                                    :
                                    <Skeleton active loading />
                            }
                            {
                                isLoaded
                                    ?
                                    (

                                        items.check_metabolite_production.png !== undefined && items.check_metabolite_production.png !== ""
                                            ?
                                            <div style={{ textAlign: "center", width: "100%" }}>
                                                <Image src={items.check_metabolite_production.png} style={{ textAlign: "center", maxWidth: "500px" }} />
                                            </div>
                                            :
                                            null

                                    )
                                    :
                                    <Skeleton active loading />
                            }

                            {
                                isLoaded
                                    ?
                                    <>
                                        {
                                            items.check_metabolite_production.Net_info !== undefined
                                                ?
                                                (
                                                    items.check_metabolite_production.Net_info.length !== 0
                                                        ?
                                                        <Card style={{ maxWidth: "1400px" }} title={<Typography.Text>{items.check_metabolite_production.net_dec}</Typography.Text>}>
                                                            <NetTable data={items.check_metabolite_production.Net_info} loading={!isLoaded} />
                                                        </Card>
                                                        :
                                                        null
                                                )
                                                :
                                                null
                                        }
                                    </>
                                    :
                                    <Skeleton active loading />
                            }

                        </Space>
                    </Panel>

                    <Panel
                        header={<a style={{ color: isLoaded ? "white" : "black" }}>Check Metabolite Yield</a>}
                        key="check_metabolite_yield"
                        extra={isLoaded ? (items.check_metabolite_yield.score !== 0 ? <CheckSquareOutlined style={{ color: "white", fontSize: "20px" }} /> : <CloseSquareOutlined style={{ color: "white", fontSize: "20px" }} />) : <LoadingOutlined />}
                        style={{ background: isLoaded ? (items.check_metabolite_yield.score !== 0 ? "#97bf60" : "#dc6068") : undefined }}
                    >
                        <Space style={{ width: "100%" }} direction="vertical" >
                            {
                                isLoaded
                                    ?
                                    <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                        {
                                            items.check_metabolite_yield.notes !== undefined && items.check_metabolite_yield.notes !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("notes")}>{
                                                    items.check_metabolite_yield.notes.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }

                                        {
                                            items.check_metabolite_yield.Details !== undefined && items.check_metabolite_yield.Details !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("Details")}>{
                                                    items.check_metabolite_yield.Details.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }

                                        {
                                            items.check_metabolite_yield.Summary !== undefined && items.check_metabolite_yield.Summary !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("Summary")}>{
                                                    items.check_metabolite_yield.Summary.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }


                                    </Descriptions>
                                    :
                                    <Skeleton active loading />
                            }
                            <Row>
                                <Col span={12}>
                                    {
                                        isLoaded
                                            ?
                                            (
                                                items.check_metabolite_yield.png !== undefined && items.check_metabolite_yield.png !== ""
                                                    ?
                                                    <div style={{ textAlign: "center", width: "100%" }}>
                                                        <Image src={items.check_metabolite_yield.png} style={{ textAlign: "center", maxWidth: "500px" }} />
                                                    </div>
                                                    :
                                                    null
                                            )
                                            :
                                            <Skeleton active loading />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        isLoaded
                                            ?
                                            (
                                                items.check_metabolite_yield.png2 !== undefined && items.check_metabolite_yield.png2 !== ""
                                                    ?
                                                    <div style={{ textAlign: "center", width: "100%" }}>
                                                        <Image src={items.check_metabolite_yield.png2} style={{ textAlign: "center", maxWidth: "500px" }} />
                                                    </div>
                                                    :
                                                    null
                                            )
                                            :
                                            <Skeleton active loading />
                                    }
                                </Col>
                            </Row>
                            {
                                isLoaded
                                    ?
                                    <>
                                        {
                                            items.check_metabolite_yield.yield_info !== undefined
                                                ?
                                                (
                                                    items.check_metabolite_yield.yield_info.length !== 0
                                                        ?
                                                        <Card style={{ maxWidth: "1400px" }} title={<Typography.Text>{items.check_metabolite_yield.yield_dec}</Typography.Text>}>
                                                            <YieldTable data={items.check_metabolite_yield.yield_info} header={getHeaders(items.check_metabolite_yield.yield_info)} />
                                                        </Card>
                                                        :
                                                        null
                                                )
                                                :
                                                null
                                        }
                                    </>
                                    :
                                    <Skeleton active loading />
                            }
                            {/* {
                                isLoaded
                                    ?
                                    (
                                        items.check_metabolite_yield.yield_dec !== undefined
                                            ?
                                            (
                                                <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                                    <Descriptions.Item label={titleCase("yield dec")}>{
                                                        items.check_metabolite_yield.yield_dec.split("\n").map(e => {
                                                            return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                        })
                                                    }</Descriptions.Item>
                                                </Descriptions>
                                            )
                                            :
                                            null
                                    )
                                    :
                                    <Skeleton active loading />
                            } */}
                        </Space>
                    </Panel>

                    <Panel
                        header={<a style={{ color: isLoaded ? "white" : "black" }}>Check Biomass Production</a>}
                        key="check_biomass_production"
                        extra={isLoaded ? (items.check_biomass_production.score !== 0 ? <CheckSquareOutlined style={{ color: "white", fontSize: "20px" }} /> : <CloseSquareOutlined style={{ color: "white", fontSize: "20px" }} />) : <LoadingOutlined />}
                        style={{ background: isLoaded ? (items.check_biomass_production.score !== 0 ? "#97bf60" : "#dc6068") : undefined }}
                    >
                        <Space style={{ width: "100%" }} direction="vertical" >
                            {
                                isLoaded
                                    ?
                                    <Descriptions bordered column={1} labelStyle={{ width: "12%" }} contentStyle={{ width: "88%" }}>
                                        {
                                            items.check_biomass_production.biomass_info !== undefined && items.check_biomass_production.biomass_info !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("biomass info")}>{
                                                    items.check_biomass_production.biomass_info.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }
                                        {
                                            items.check_biomass_production.Summary !== undefined && items.check_biomass_production.Summary !== ""
                                                ?
                                                <Descriptions.Item label={titleCase("Summary")}>{
                                                    items.check_biomass_production.Summary.split("\n").map(e => {
                                                        return <Typography.Paragraph>{e}</Typography.Paragraph>
                                                    })
                                                }</Descriptions.Item>
                                                :
                                                null
                                        }

                                    </Descriptions>
                                    :
                                    <Skeleton active loading />
                            }

                        </Space>
                    </Panel>
                </Collapse>
            </>
        </Space>
    )
}
